import { createI18n } from 'vue-i18n';
import { useLanguageStore } from './stores/language';

const messages = {
    ca: {
        menu: {
            title: 'Tria el<br>teu sopar',
            subtitle: 'I t\'avisem quan estigui llest!',
            add: 'Afegir!',
            see_cart: 'Veure comanda',
            next_step: 'Tramitar comanda',
            go_back: 'Tornar enrere',
            ok: 'Acceptar'
        },
        order_data: {
            title: "La meva<br>comanda",
            name: "Nom i cognoms",
            email: "Email",
            phone: "Telèfon",
            take_away: "Take away",
            delivery: "Delivery",
            only_palafrugell: "Només a Palafrugell",
            delivery_text: "Podràs recollir la teva comanda un cop estigui llesta al nostre local, al C/Torres i Jonama, 108, de <b>Palafrugell</b>.",
            town: "Població",
            address: "Adreça",
            datetime: "Quan vols rebre la teva comanda?",
            cancel: "Cancelar",
            accept_policies: "Accepto el tractament de les meves dades per finalitats comercials",
            accept_newsletter: "Accepto rebre comunicacions comercials que siguin del meu interés",
        },
        summary: {
            total: 'Import total',
            pay: 'Pagar comanda',
            delivery_time: 'La teva comanda estarà llesta el {date} aproximadament a les',
            delivery_time_today: 'La teva comanda estarà llesta aproximadament a les',
            invalid_payment: 'No s\'ha pogut processar el pagament, torna-ho a provar de nou',
            loading: "Carregant...",
            confirmed_after_pay: "La teva comanda serà confirmada un cop realitzis el pagament"
        },
        confirmation: {
            valid_payment: 'La teva comanda s\'ha processat correctament. Bon profit!',
            we_will_send_you_email: 'T\'enviarem un email quan la puguis passar a recollir'
        },
        form: {
            hour_delivery: 'Selecciona a quina hora vols que t\'entreguem la teva comanda',
            hour_takeaway: 'Selecciona a quina hora vols recollir la teva comanda'
        },
        cart: {
            my_order: 'La meva<br>comanda',
            delivery: 'A domicili',
            delivery_desc: 'Et portem la pizza a casa!',
            total: 'Import total',
            empty: 'Comanda buida, selecciona algun producte per poder continuar',
            max_pizzas: 'El màxim de pizzes que pots encarregar a través de l\'aplicació són 10, si vols fer una comanda més gran, truca\'ns al <a href=\'tel:+34657771155\' class=\'underline\'>657771155</a> i t\'atendrem. Gràcies!'
        }
    },
    es: {
        menu: {
            title: 'Elige tu cena',
            subtitle: '¡Y te avisamos cuando esté lista!',
            add: '¡Añadir!',
            see_cart: 'Ver pedido',
            next_step: 'Tramitar pedido',
            go_back: 'Volver atrás',
            ok: 'Aceptar'
        },
        order_data: {
            title: "Mi<br>pedido",
            name: "Nombre y apellidos",
            email: "Email",
            phone: "Teléfono",
            take_away: "Take away",
            delivery: "Delivery",
            only_palafrugell: "Sólo en Palafrugell",
            delivery_text: "Podrás recoger tu pedido una vez esté lista en nuestro local, en la C/Torres y Jonama, 108, de <b>Palafrugell</b>.",
            town: "Población",
            address: "Dirección",
            datetime: "¿Cuándo quieres recibir tu pedido?",
            cancel: "Cancelar",
            accept_policies: "Acepto el tratamiento de mis datos para fines comerciales",
            accept_newsletter: "Acepto recibir comunicaciones comerciales que sean de mi interés",
        },
        summary: {
            total: 'Importe total',
            pay: 'Pagar pedido',
            delivery_time: 'Tu pedido estará listo el {date} aproximadamente a las',
            delivery_time_today: 'Tu pedido estará listo aproximadamente a las',
            invalid_payment: 'No se pudo procesar el pago, vuelve a intentarlo de nuevo',
            loading: "Cargando...",
            confirmed_after_pay: "Su pedido será confirmado cuando realize el pago"
        },
        confirmation: {
            valid_payment: 'Tu pedido se ha procesado correctamente. ¡Buen provecho!',
            we_will_send_you_email: 'Te mandaremos un email cuando puedas venir a recogerlo'
        },
        form: {
            hour_delivery: 'Selecciona a qué hora quieres que te entreguemos tu pedido',
            hour_takeaway: 'Selecciona a qué hora quieres recoger tu pedido'
        },
        cart: {
            my_order: 'Mi<br>pedido',
            delivery: 'A domicilio',
            delivery_desc: '¡Te llevamos tu pizza a casa!',
            total: 'Importe total',
            empty: 'Pedido vacío, selecciona algún producto para poder continuar',
            max_pizzas: "El máximo de pizzas que puedes encargar a través de la aplicación son 10, si quieres hacer un pedido mayor, llámanos al <a href='tel: +34657771155' class='underline'>657771155</a> y te atenderemos. ¡Gracias!"
        }
    },
    en: {
        menu: {
            title: 'Choose your<br>dinner',
            subtitle: 'And we\'ll let you know when it\'s ready!',
            add: 'Add!',
            see_cart: 'View Order',
            next_step: 'Process order',
            go_back: 'Go back',
            ok: 'Ok'
        },
        order_data: {
            title: "My<br>order",
            name: "Name",
            email: "Email",
            phone: "Phone",
            take_away: "Take away",
            delivery: "Delivery",
            only_palafrugell: "Only in Palafrugell",
            delivery_text: "You can pick up your order once it is ready at our restaurant, at C/Torres y Jonama, 108, <b>Palafrugell</b>.",
            town: "Population",
            address: "Address",
            datetime: "When do you want to receive your order?",
            cancel: "Cancel",
            accept_policies: "I accept the processing of my data for commercial purposes",
            accept_newsletter: "I accept to receive commercial communications that are of interest to me",
        },
        summary: {
            total: 'Total amount',
            pay: 'Pay order',
            delivery_time: 'Your order will be ready on {date} approximately at',
            delivery_time_today: 'Your order will be ready approximately at',
            invalid_payment: 'Could not process payment, please try again',
            loading: "Loading...",
            confirmed_after_pay: "Your order will be confirmed once you make the payment"
        },
        confirmation: {
            valid_payment: 'Your order has been successfully processed. Bon Appetit!',
            we_will_send_you_email: 'We will send you an email when you can come pick it up'
        },
        form: {
            hour_delivery: 'Select what time you want us to deliver your order',
            hour_takeaway: 'Select what time you want to pick up your order'
        },
        cart: {
            my_order: 'My<br>order',
            delivery: 'Delivery',
            delivery_desc: 'We bring your pizza home!',
            total: 'Total amount',
            empty: 'Empty order, select a product to continue',
            max_pizzas: "The maximum number of pizzas that you can order through the application is 10, if you want to place a larger order, call us at <a href='tel: +34657771155' class='underline'>657771155</a> and we will assist you. Thank you!"
        }
    },
    fr: {
        menu: {
            title: 'Choisissez votre dîner',
            subtitle: 'Et nous vous préviendrons quand ce sera prêt!',
            add: 'Ajouter!',
            see_cart: 'Voir la commande',
            next_step: 'Traiter la commande',
            go_back: 'Revenir en arrière',
            ok: 'J\'accepte'
        },

        order_data: {
            title: "Ma<br>commande",
            name: "Nom et prénom",
            email: "E-mail",
            phone: "Téléphone",
            take_away: "A emporter",
            delivery: "Livraison",
            only_palafrugell: "Uniquement à Palafrugell",
            delivery_text: "Vous pouvez récupérer votre commande une fois prête dans notre restaurant, C/Torres y Jonama, 108, <b>Palafrugell</b>.",
            town: "Population",
            address: "Adresse",
            datetime: "Quand souhaitez-vous recevoir votre commande?",
            cancel: "Annuler",
            accept_policies: "J'accepte le traitement de mes données à des fins commerciales",
            accept_newsletter: "J'accepte de recevoir des communications commerciales qui m'intéressent",
        },

        summary: {
            total : 'Montant total',
            pay: 'Payer la commande',
            delivery_time: 'Votre commande sera prête le {date} approximativement à',
            delivery_time_today: 'Votre commande sera prête approximativement à',
            invalid_payment: 'Impossible de traiter le paiement, veuillez réessayer',
            loading: "En cours...",
            confirmed_after_pay: "Votre commande sera confirmée une fois le paiement effectué"
        },
        confirmation: {
            valid_payment: 'Votre commande a été traitée avec succès. Bon appétit!',
            we_will_send_you_email: 'Nous vous enverrons un e-mail lorsque vous pourrez venir le chercher'
        },
        form: {
            hour_delivery: "Sélectionnez l'heure à laquelle vous souhaitez que nous livrions votre commande",
            hour_takeaway: "Sélectionnez l'heure à laquelle vous souhaitez récupérer votre commande"
        },
        cart: {
            my_order: 'Ma<br>commande',
            delivery: 'Livraison',
            delivery_desc: 'Nous ramenons votre pizza à la maison!',
            total: 'Montant total',
            empty: 'Vider la commande, sélectionner un produit pour continuer',
            max_pizzas: "Le nombre maximum de pizzas que vous pouvez commander via l'application est de 10, si vous souhaitez passer une commande plus importante, appelez-nous au <a href='tel: +34657771155' class='underline'>657771155</a> et nous vous assistera. Merci!"
        }
    }
}

export function installI18n(app) {
    const i18n = createI18n({
        locale: useLanguageStore().currentAppLocale || 'ca', // set locale
        fallbackLocale: 'es', // set fallback locale
        messages, // set locale messages
    });
    app.use(i18n);
    return i18n;
}

